import { render, staticRenderFns } from "./addScratchModle.vue?vue&type=template&id=11c6fb73&scoped=true"
import script from "./addScratchModle.vue?vue&type=script&lang=js"
export * from "./addScratchModle.vue?vue&type=script&lang=js"
import style0 from "./addScratchModle.vue?vue&type=style&index=0&id=11c6fb73&lang=scss&scoped=true"
import style1 from "./addScratchModle.vue?vue&type=style&index=1&id=11c6fb73&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c6fb73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11c6fb73')) {
      api.createRecord('11c6fb73', component.options)
    } else {
      api.reload('11c6fb73', component.options)
    }
    module.hot.accept("./addScratchModle.vue?vue&type=template&id=11c6fb73&scoped=true", function () {
      api.rerender('11c6fb73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/quesbank-manage/addScratchModle.vue"
export default component.exports